export const shouldEnableChatPresencePreview = (
  environment: string | undefined = process.env.NODE_ENV,
): boolean => environment !== 'production';
